import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }
  currentYear:number = 0
  ngOnInit() {
    let date = new Date();
    this.currentYear = date.getFullYear()
  }
  
  scroll(){
    window.scrollTo(380,380)
  }
  viewOtherLocations()

  {
    
  }
}
